import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './components/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import PaywallGate from './components/PaywallGate';
import { Toaster } from './components/ui/sonner';
import './App.css';

import Landing from './pages/Landing';
import Login from './pages/Login';
import Register from './pages/Register';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import VerifyEmail from './pages/VerifyEmail';
import Checkout from './pages/Checkout';
import PaymentSuccess from './pages/PaymentSuccess';
import PaymentCancel from './pages/PaymentCancel';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
import Dashboard from './pages/Dashboard';
import Profile from './pages/Profile';
import Library from './pages/Library';
import Discover from './pages/Discover';
import Connections from './pages/Connections';
import Messages from './pages/Messages';
import BookClubs from './pages/BookClubs';
import AdminPanel from './pages/AdminPanel';
import PublicProfile from './pages/PublicProfile';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <div className="App">
          <Routes>
            {/* Public */}
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/verify-email" element={<VerifyEmail />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy" element={<Privacy />} />

            {/* Auth required but no paywall */}
            <Route path="/checkout" element={<ProtectedRoute><Checkout /></ProtectedRoute>} />
            <Route path="/payment/success" element={<ProtectedRoute><PaymentSuccess /></ProtectedRoute>} />
            <Route path="/payment/cancel" element={<ProtectedRoute><PaymentCancel /></ProtectedRoute>} />
            <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
            <Route path="/library" element={<ProtectedRoute><Library /></ProtectedRoute>} />

            {/* Paywall gated (require paid) */}
            <Route path="/dashboard" element={<PaywallGate><Dashboard /></PaywallGate>} />
            <Route path="/discover" element={<PaywallGate><Discover /></PaywallGate>} />
            <Route path="/connections" element={<PaywallGate><Connections /></PaywallGate>} />
            <Route path="/messages" element={<PaywallGate><Messages /></PaywallGate>} />
            <Route path="/bookclubs" element={<PaywallGate><BookClubs /></PaywallGate>} />
            <Route path="/users/:userId" element={<PaywallGate><PublicProfile /></PaywallGate>} />

            {/* Admin only */}
            <Route path="/admin" element={<ProtectedRoute><AdminPanel /></ProtectedRoute>} />

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </div>
        <Toaster position="top-right" />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
